angular.module('impactx.system').controller('LogBrowserListCtrl', [
    'selectedListItems',
    'FileHelperService',
    '$routeParams',
    'dataGen',
    '$route',
    '$scope',
    '$redirect',
    '$window',
    'DownloadService',
    LogBrowserListCtrl]);

function LogBrowserListCtrl(selectedListItems, FileHelperService, $routeParams, dataGen, $route, $scope, $redirect, $window, DownloadService)
{
    var ctrl = this;
    $scope.newWindow = {};

    selectedListItems.clearSelectedItems();

    ctrl.openFile = function () {
        var parameters = {
            paramName: "filename",
            paramValue: selectedListItems.getFirstSelectedItem().name
        };
        if($routeParams.path){
            parameters.paramValue = $routeParams.path + '/' + parameters.paramValue;
        }
        DownloadService.openDownloadPost('/systemadministration/logbrowser/download', parameters);
    };

    ctrl.redirectToFolder = function () {
        if (ctrl.meta.params.listConfig.filterBlocks)
        {
            var filterBlocks = ctrl.meta.params.listConfig.filterBlocks;
            for (var j = 0; j < filterBlocks.length; j++)
            {
                var filters = filterBlocks[j].filterValues;
                for (var i = 0; i < filters.length; i++)
                {
                    filters[i].stringValue = "";
                }
            }
        }
        $redirect.redirectTo(null, "logfilebrowser/" + ($routeParams.path ? ($routeParams.path + "\\") : "") + selectedListItems.getFirstSelectedItem().name);
    };

    ctrl.isFolderAndCanOpen = function () {
        if (selectedListItems.isSingleSelection())
        {
            var selectedItem = selectedListItems.getFirstSelectedItem();
            if (selectedItem && selectedItem.isFolder)
            {
                return true;
            }
        }
        return false;
    };

    ctrl.isFileAndCanOpen = function () {
        if (selectedListItems.isSingleSelection())
        {
            var selectedItem = selectedListItems.getFirstSelectedItem();
            if (selectedItem && !selectedItem.isFolder)
            {
                return true;
            }
        }
        return false;
    };

    ctrl.handleFileSelect = function (evt) {
        var file = evt.currentTarget.files[0];
        $(this).val("");
        ctrl.handleFile(evt, file);
    };

    var buttonDefinition = [{
        label: "open",
        action: ctrl.redirectToFolder,
        condition: ctrl.isFolderAndCanOpen,
        process: 'LogFileBrowser'
    }, {
        label: "download",
        action: ctrl.openFile,
        condition: ctrl.isFileAndCanOpen,
        process: 'LogFileBrowser'
    }];

    ctrl.meta = {
        rowTemplate: 'modules/system/templates/filebrowserlist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/systemadministration/logbrowser/list',
        id: "logbrowserlist",
        buttonDefinition: buttonDefinition,
        fileHelperService: FileHelperService,
        valuesString: [{name: "path", value: $routeParams.path}],
        handleFileSelect: ctrl.handleFileSelect
    };
    ctrl.getMeta = function () {
        return this.meta;
    };
}

